import { Show, createEffect } from 'solid-js';
import { useNavigate } from '@solidjs/router';
import { useAuthenticatedUser } from '../../contexts/AuthContext';
import { useSessionRecovery } from '../../hooks/useSessionRecovery';

export const SessionRecoveryBar = () => {
	const { hasActiveGames, hasMatchmakingQueue, isLoading, user } = useAuthenticatedUser();
	const { sessions } = useSessionRecovery();
	const navigate = useNavigate();

	// Auto-navigate to active game if there's only one
	createEffect(() => {
		// Only auto-navigate if user data is loaded and we're not on a game page
		if (isLoading()) {
			console.log('🔄 [SessionRecoveryBar] Waiting for user data to load...');
			return;
		}

		const currentUser = user();
		if (!currentUser) {
			console.log('🔄 [SessionRecoveryBar] No user data available');
			return;
		}

		const sessionList = sessions();
		const currentPath = window.location.pathname;

		console.log('🔄 [SessionRecoveryBar] Checking for auto-navigation:', {
			sessions: sessionList.length,
			activeGameIds: currentUser.activeGameIds,
			currentPath,
			isLoading: isLoading(),
		});

		if (sessionList.length === 1 && sessionList[0]?.type === 'game') {
			const gameId = sessionList[0].id;
			// Check if we're not already on this game page or any game page
			if (!currentPath.includes(`/game/`)) {
				console.log('🔄 [SessionRecoveryBar] Auto-navigating to active game:', gameId);
				navigate(`/game/${gameId}`);
			} else if (!currentPath.includes(`/game/${gameId}`)) {
				// We're on a different game page, navigate to the correct one
				console.log('🔄 [SessionRecoveryBar] Navigating from different game to active game:', gameId);
				navigate(`/game/${gameId}`);
			}
		}
	});

	const hasActiveSessions = () => hasActiveGames() || hasMatchmakingQueue();

	// Show a minimal indicator when there's an active game
	return (
		<Show when={hasActiveSessions() && sessions().length > 0}>
			<div class="fixed bottom-4 right-4 rounded border border-green bg-black px-4 py-2 text-sm text-green shadow-lg">
				<Show
					when={sessions().length === 1 && sessions()[0]?.type === 'game'}
					fallback={
						<div class="flex items-center space-x-2">
							<div class="h-2 w-2 animate-pulse rounded-full bg-green" />
							<span>Matchmaking active...</span>
						</div>
					}
				>
					<div class="flex items-center space-x-2">
						<div class="h-2 w-2 rounded-full bg-green" />
						<span>Game in progress</span>
					</div>
				</Show>
			</div>
		</Show>
	);
};
